export default {
	phone_call_ai_summary: 'Summary',
	phone_call_ai_summary_label: 'AI Summary',
	phone_call_by: 'by',
	phone_call_call: 'Call',
	phone_call_call_back: 'Call back',
	phone_call_call_incoming: 'Incoming call',
	phone_call_call_label: 'Call',
	phone_call_call_outgoing: 'Outgoing call',
	phone_call_callback_request_field_label: 'Callback request',
	phone_call_caller_name_add_label: 'Create new caller name',
	phone_call_caller_name_apply_label: 'Apply',
	phone_call_caller_name_cancel_label: 'Cancel',
	phone_call_caller_name_edit_label: 'Edit caller name',
	phone_call_caller_name_label: 'Caller name',
	phone_call_caller_number_label: 'Caller number',
	phone_call_contact_picture_action_label: 'Edit contact picture',
	phone_call_contact_picture_cancel_label: 'Cancel',
	phone_call_contact_picture_current_alt: 'Current contact picture',
	phone_call_contact_picture_dialog_title: 'Edit caller contact picture',
	phone_call_contact_picture_drop_hint: 'Drop image here',
	phone_call_contact_picture_google_search_label: 'Google image search',
	phone_call_contact_picture_invalid_file_error: 'Please select an image file.',
	phone_call_contact_picture_preview_alt: 'New contact picture preview',
	phone_call_contact_picture_preview_empty: 'No image selected yet.',
	phone_call_contact_picture_preview_label: 'Preview',
	phone_call_contact_picture_remove_confirm_cancel_label: 'Cancel',
	phone_call_contact_picture_remove_confirm_message: 'The contact picture will be removed for this phone number.',
	phone_call_contact_picture_remove_confirm_ok_label: 'Remove',
	phone_call_contact_picture_remove_confirm_title: 'Remove contact picture?',
	phone_call_contact_picture_remove_error: 'The contact picture could not be removed.',
	phone_call_contact_picture_remove_label: 'Remove contact picture',
	phone_call_contact_picture_remove_success: 'Contact picture removed',
	phone_call_contact_picture_replace_label: 'Choose another image',
	phone_call_contact_picture_save_error: 'The contact picture could not be saved.',
	phone_call_contact_picture_save_label: 'Save',
	phone_call_contact_picture_save_success: 'Contact picture saved',
	phone_call_contact_picture_source_upload_label: 'Choose image',
	phone_call_contact_picture_target_label: 'Contact',
	phone_call_details_call_accepted_by_label: 'Accepted by',
	phone_call_details_call_duration_label: 'Duration',
	phone_call_details_call_extension_label: 'Extension',
	phone_call_details_call_list_label: 'Call list',
	phone_call_details_call_minutes_label: 'minutes',
	phone_call_details_tab_label: 'Details',
	phone_call_for: 'for',
	phone_call_hangup: 'Hangup',
	phone_call_history_tab_label: 'History',
	phone_call_info_tab_label: 'Info',
	phone_call_initialize_phone_call: 'Initialize call to',
	phone_call_open_the_phone_book: 'Open phone book',
	phone_call_outgoing_call: 'Outgoing call',
	phone_call_page_of: "of {'{'}totalPages{'}'}",
	phone_call_page_report: 'Showing {first} - {last} of {totalRecords}',
	phone_call_phone_book_duplicates_empty: 'No duplicates found',
	phone_call_phone_book_edit_cancel: 'Cancel',
	phone_call_phone_book_edit_name: 'Edit name',
	phone_call_phone_book_edit_save: 'Save',
	phone_call_phone_book_empty: 'No phone book entries',
	phone_call_phone_book_ignore_entry_question: 'Ignore spelling',
	phone_call_phone_book_ignored_entry: 'Ignored entry',
	phone_call_phone_book_loading: 'Loading phonebook...',
	phone_call_phone_book_merge: 'Copy spelling',
	phone_call_phone_book_merge_notification: 'Processing',
	phone_call_phone_book_phone_book_tab_label: 'Phonebook',
	phone_call_phone_book_phone_call: 'Phone call',
	phone_call_phone_book_phone_calls: 'Phone calls',
	phone_call_phone_book_phonetic_duplicates_cleaner_tab_label: 'Duplicates',
	phone_call_phone_book_save_notification: 'Update phone book entry',
	phone_call_phone_book_tab_manager_tab_label: 'Phonebook',
	phone_call_phone_book_table_header_search_placeholder: 'Search',
	phone_call_phone_table_name_column_label: 'Name',
	phone_call_phone_table_number_column_label: 'Number',
	phone_call_print: 'Print',
	phone_call_reason_label: 'Call reason',
	phone_call_reverse_number_search: 'Reverse number search',
	phone_call_save_failed_notification: 'Phone call could not be saved',
	phone_call_saved_notification: 'Phone call saved',
	phone_call_spam_check: 'Spamcheck',
	phone_call_time_label: "o'clock",
	phone_call_with_callback_request: 'with callback request',
	phone_call_without_callback_request: 'without callback request',
};
